import { HttpApi, HttpApiEndpoint, HttpApiGroup, OpenApi } from "@effect/platform"
import { InternalServerError } from "@effect/platform/HttpApiError"
import { Schema } from "effect"
import { PaddleControllerMiddleware } from "./middleware"

export const ApplicationIdParam = Schema.Number.pipe(Schema.brand("ApplicationId")).annotations({
  identifier: "ApplicationIdParam",
})

export const PaddleEnvironmentParam = Schema.Literal("live", "test").annotations({
  identifier: "@open-revenue/paddle/EnvironmentParam",
})

export const PaddleApi = HttpApiGroup.make("paddle")
  .annotate(OpenApi.Description, "Paddle API")
  .add(
    HttpApiEndpoint.get(
      "getPaddleConfigurationStatus",
      "/applications/:applicationId/paddle/:env/configuration-status"
    )
      .setPath(
        Schema.Struct({
          applicationId: Schema.NumberFromString,
          env: PaddleEnvironmentParam,
        })
      )
      .addSuccess(
        Schema.Struct({
          valid: Schema.Boolean,
          hasOAuth: Schema.Boolean,
          tokenExpired: Schema.Boolean,
          webhookConfigured: Schema.Boolean,
          hostedCheckoutUrl: Schema.NullOr(Schema.String),
        })
      )
      .addError(InternalServerError)
      .middleware(PaddleControllerMiddleware)
      .annotate(OpenApi.Summary, "GetPaddleConfigurationStatus")
  )
  .add(
    HttpApiEndpoint.post("connectPaddle", "/applications/:applicationId/paddle/:env/connect")
      .setPath(
        Schema.Struct({
          applicationId: Schema.NumberFromString,
          env: PaddleEnvironmentParam,
        })
      )
      .setPayload(Schema.Struct({ accessToken: Schema.String }))
      .addSuccess(
        Schema.Struct({
          status: Schema.Literal("success"),
        })
      )
      .addError(InternalServerError)
      .middleware(PaddleControllerMiddleware)
      .annotate(OpenApi.Summary, "ConnectPaddle")
  )
  .add(
    HttpApiEndpoint.post(
      "ensureWebhookExists",
      "/applications/:applicationId/paddle/:env/webhook/ensure"
    )
      .setPath(
        Schema.Struct({
          applicationId: Schema.NumberFromString,
          env: PaddleEnvironmentParam,
        })
      )
      .addSuccess(
        Schema.Struct({
          status: Schema.Literal("success"),
        })
      )
      .addError(InternalServerError)
      .middleware(PaddleControllerMiddleware)
      .annotate(OpenApi.Summary, "EnsurePaddleWebhookExists")
  )
  .add(
    HttpApiEndpoint.del("removeWebhook", "/applications/:applicationId/paddle/:env/webhook")
      .setPath(
        Schema.Struct({
          applicationId: Schema.NumberFromString,
          env: PaddleEnvironmentParam,
        })
      )
      .addSuccess(
        Schema.Struct({
          status: Schema.Literal("success"),
        })
      )
      .addError(InternalServerError)
      .middleware(PaddleControllerMiddleware)
      .annotate(OpenApi.Summary, "RemovePaddleWebhook")
  )
